import { Error404, SuspenseFallback } from '@/components';
import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from '~pages-config';

const _routes = [...routes, { path: '*', element: <Error404 /> }];

export default function AppRouter() {
  return (
    <div>
      <Suspense fallback={<SuspenseFallback />}>{useRoutes(_routes)}</Suspense>
    </div>
  );
}
